import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "lg:flex justify-stretch pb-xs items-center" }
const _hoisted_2 = {
  key: 1,
  class: "w-1/4"
}
const _hoisted_3 = { class: "flex lg:mx-l lg:w-2/4 justify-stretch my-xs lg:my-xs" }
const _hoisted_4 = { class: "mt-0 mb-l" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "hidden" }
const _hoisted_7 = { class: "lg:flex justify-between mt-xs" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-xs" }, null, -1)

import { computed, ref, onMounted } from "vue";
import UButton from "@/components/UButton.vue";
import { Message, OrderBox, MessageModelClass } from "@/interfaces/message";
import { MessageType } from "@/interfaces/enum/messageType";
import RoundedCard from "@/components/RoundedCard.vue";
import { encryptAndSaveMessage } from "@/helpers/requestHelpers/ordersRequests";
import { Conversation } from "@/interfaces/conversation";
import IconButton from "@/components/IconButton.vue";
import { useOrdersStore } from "@/store/ordersStore";
import { upcomingDates } from "@/helpers/datehelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderBoxManagement',
  props: {
    messages: {},
    conversation: {},
    openBox: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const boxForm = ref<any>({});

const selectedBoxId = ref<number>(0);

const props = __props;

const suggestions = computed(() => {
  let boxes = Array.from(useOrdersStore().messages?.values() ?? []).filter(
    (message) => message.type == MessageType.box
  );

  let addresses: Set<OrderBox> = new Set();
  let addressesCopy: Set<string> = new Set();
  boxes.forEach((box) => {
    if (addresses.size > 3) return;
    if (
      box.medication_box &&
      box.medication_box.deleted != true &&
      !addressesCopy.has(
        `${box.medication_box.address1}${box.medication_box.address2}`
      ) &&
      box.medication_box.address1.includes(boxForm.value.address1 ?? "") &&
      (!boxForm.value.address2 ||
        boxForm.value.address2 == "" ||
        boxForm.value.address1 == "")
    ) {
      addresses.add(box.medication_box);
      addressesCopy.add(
        `${box.medication_box.address1}${box.medication_box.address2}`
      );
    }
  });
  return addresses;
});

function copyBox(box: OrderBox) {
  boxForm.value.address1 = box.address1;
  boxForm.value.address2 = box.address2 ?? "";
  boxForm.value.zip = box.zip;
  boxForm.value.city = box.city;
}

async function saveBox() {
  let id: number | undefined = undefined;

  if (selectedBoxId.value < boxes.value.length) {
    id = boxes.value[selectedBoxId.value].id;
  }
  if (boxForm.value.date && boxForm.value.date.date) {
    boxForm.value.date = boxForm.value.date.date;
  }
  if (boxForm.value.date && boxForm.value.date.length == 0) {
    // deselect results in []
    boxForm.value.date = null;
  }
  if (id) {
    window._paq.push([
      "trackEvent",
      "Box-Management",
      "Box updated via form",
      undefined,
    ]);
  } else {
    window._paq.push(["trackEvent", "Box-Management", "Box added", undefined]);
  }
  try {
    await encryptAndSaveMessage(props.conversation, {
      type: 1,
      id: id,
      decrypted_message: JSON.stringify(boxForm.value as OrderBox),
    } as MessageModelClass);

    if (props.openBox !== undefined) {
      emits("close");
    }
  } catch (e) {
    console.error(e);
  }
}

function updateBoxForm() {
  boxForm.value = JSON.parse(
    boxes.value[selectedBoxId.value]?.decrypted_message ??
      `{"name": "Kiste ${selectedBoxId.value + 1}"}`
  );
}

const boxes = computed<Message[]>(() => {
  return (
    props.messages.filter((message) => message.type == MessageType.box) ?? []
  );
});

onMounted(() => {
  selectedBoxId.value = props.openBox ?? boxes.value.length;
  updateBoxForm();

  window._paq.push([
    "trackEvent",
    "Box-Management",
    "Opened box management",
    undefined,
  ]);
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (selectedBoxId.value < boxes.value.length)
        ? (_openBlock(), _createBlock(UButton, {
            key: 0,
            class: "w-full lg:w-1/4",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
        boxForm.value.deleted = !boxForm.value.deleted;
        saveBox();
      }),
            color: "red"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(boxForm.value.deleted ? "Wiederherstellen" : "Löschen"), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("span", _hoisted_2)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(IconButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedBoxId.value > 0 ? selectedBoxId.value-- && updateBoxForm() : null)),
          position: "left",
          class: "flex-2",
          icon: "left"
        }),
        _createVNode(UButton, {
          position: "middle",
          color: "white",
          class: _normalizeClass(["flex-1", {
          'line-through': boxForm.value.deleted,
        }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(selectedBoxId.value == boxes.value.length
            ? `Neue Kiste`
            : boxes.value[selectedBoxId.value].medication_box?.name ?? "unbenannte Kiste"), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(IconButton, {
          icon: "right",
          position: "right",
          class: "flex-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (
          selectedBoxId.value < boxes.value.length
            ? ++selectedBoxId.value && updateBoxForm()
            : null
        ))
        })
      ]),
      (selectedBoxId.value < boxes.value.length)
        ? (_openBlock(), _createBlock(UButton, {
            key: 2,
            onClick: _cache[3] || (_cache[3] = ($event: any) => {
        selectedBoxId.value = boxes.value.length;
        updateBoxForm();
      }),
            class: "lg:w-1/4 w-full",
            color: "orange"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Neue Kiste")
            ]),
            _: 1
          }))
        : (boxes.value.length > 0)
          ? (_openBlock(), _createBlock(UButton, {
              key: 3,
              onClick: _cache[4] || (_cache[4] = ($event: any) => {
        selectedBoxId.value = 0;
        updateBoxForm();
      }),
              class: "lg:w-1/4 w-full",
              color: "orange"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Kisten bearbeiten")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_FormKit, {
      type: "form",
      id: "boxForm",
      onSubmit: saveBox,
      modelValue: boxForm.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((boxForm).value = $event)),
      actions: false
    }, {
      default: _withCtx(() => [
        _createVNode(RoundedCard, { color: "gray" }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Name",
              name: "name",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Strasse / Hausnummer",
              name: "address1",
              validation: "required"
            }),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (address) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: `${address.address1}${address.address2}`,
                  class: "text-green text-right",
                  onClick: ($event: any) => (copyBox(address))
                }, _toDisplayString(address.address1) + " " + _toDisplayString(address.address2), 9, _hoisted_5))
              }), 128))
            ]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Adresszusatz",
              name: "address2"
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "PLZ",
              name: "zip",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Stadt",
              name: "city",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "multiselect",
              label: "Abweichendes Lieferdatum",
              name: "date",
              placeholder: "Lieferdatum",
              "track-by": "date",
              class: "w-multiselectbig",
              searchable: true,
              reset: "Kein abweichendes Lieferdatum",
              "option-label": "label",
              "select-options": _unref(upcomingDates)(),
              help: "Falls diese Kiste nicht zur selben Zeit wie die restliche Bestellung geliefert wird, kann hier das Lieferdatum dieser Kiste hinterlegt werden."
            }, null, 8, ["select-options"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FormKit, {
                type: "checkbox",
                label: "Gelöscht",
                name: "deleted",
                validation: "boolean"
              })
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FormKit, {
            type: "button",
            label: "Abbrechen",
            class: "bg-white",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
          }),
          _hoisted_8,
          _createVNode(_component_FormKit, {
            type: "submit",
            label: 
          selectedBoxId.value < boxes.value.length ? 'Kiste speichern' : 'Kiste hinzufügen'
        
          }, null, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})